import React from "react";
import { Space, Button, Popconfirm } from "antd";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import DataTable from "../../components/DataTable";

export default function HiveTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onDeleteTable,
  onViewTable,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Table Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Actions",
      key: "actions",
      width: "15%",
      align: "center",
      render: (_, r) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => onViewTable(r)}
            style={{ color: "#D97A07" }}
            title="View Database Details"
          />
          {!isRoleUser && (
            <Popconfirm
              title="Confirm Deletion"
              description={`Are you sure you want to delete table "${r.name}"?`}
              onConfirm={() => onDeleteTable(r.name)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                title="Delete Table"
              />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
  return (
    <DataTable
      rowKey="name"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
